var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['tab', { active: _vm.active }]},[_c('div',{staticClass:"icon-wrap"},[(_vm.icon)?_c('dash-icon',{attrs:{"icon":_vm.icon,"as-svg":""}}):_vm._e()],1),_c('div',{staticClass:"label"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }